module.exports = __webpack_public_path__ + "static/media/marker.faf65ad4.webp";